module.exports = __webpack_public_path__ + "assets/48a944922203a009330ea4ca6c4c66ac.svg";